import { useEffect, useState, type ReactElement } from 'react';
import { sgwtConnect } from '@/sgwt/sgwtConnect.ts';
import { ApplicationList } from '@/components/application/applicationList';
import UnauthorizedAccess from "@/components/healths/UnauthorizedAccess.tsx";
import type { ISGWTConnectOpenIDStandardClaims, SGWTConnectError } from '@sgwt/connect-core';

export function ChromeExtension(): ReactElement {


  const [icId, setIcId] = useState('');

    useEffect(() => {
      sgwtConnect.fetchUserInfo((error: SGWTConnectError | null, claims?: any) => {
        if (error) {
          localStorage.setItem('fetchUserInfo.error', error.code);
        }
        if (claims) {
          setIcId(claims.contact_id);
        }
      });
    }, []);

  if (sgwtConnect.isAuthorized())
    {
      return <div>
        <h2>Chrome & Edge Extension is now available</h2>
        <br/>
        <p>
          Chrome extension is available here: <a href="https://chromewebstore.google.com/detail/sgm-status/hfabdgioejknipehcjegpcikhbeecffj?utm_source=item-share-cb" target='blank'>Install Now</a>.<br/>
          <b>You can install it on <a href="https://devportal.group.socgen/dev-tool/chromium"  target='blank'>chromium</a>. </b>
        </p>
        <p>
          Edge extension will be available here: <a href="https://microsoftedge.microsoft.com/addons/detail/sgmstatus/kgcffmkjgnbbakklfcmnefccalngadie" target='blank'>Install Now</a>.<br/>
          <b>Currently this extension is in development and not yet authorized in edge by the Organization.</b>
        </p>
        <h5 className="mt-4 mb-4">1. Configuration</h5>
        After installing the extension, you can access option by right clicking on the extension and choose "option in the context menu".<br/><br/>
        <img src="/chrom_extension_1.png" alt="Option" style={{ border: "1px #ccc solid"}} />
        <br/><br/>
        A new option page should be displayed:<br/>
        <img src="/chrom_extension_2.png" alt="Another Option" style={{ border: "1px #ccc solid"}} />
        <br/><br/>
        Then you should fill the form with your details and click "Save" to apply the settings.<br/>
        <ul>
          <li>Username (Ic contactId): <b>{icId}</b></li>
          <li>API URL: <b>https://sgm-status-batch.fr.world.socgen/api/v1/events</b></li>
          <li>Website URL: <b>https://status.sgmarkets.com</b></li>
        </ul>

        <h5 className="mt-5 mb-4">2. Functionalities</h5>
        <p>
          <ul>
            <li>Update Icon badge when the number of unhealthy website changes</li>
            <li>Receive notifications for important updates</li>
            <li>Direct click to access status.sgmarkets.com portal</li>
          </ul>
        </p>
        <br/>
        <br/>
        <p>Welcome to the Chrome Extension. Enjoy your experience!</p>
        <p>Make sure to check out the latest features!</p>
        </div>;
    }
  return <UnauthorizedAccess />;
}